var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00195 7.00065C8.17258 7.00065 8.34321 7.06597 8.47319 7.19595L11.8065 10.5279C12.0671 10.7885 12.0671 11.2104 11.8065 11.4711C11.5459 11.731 11.1246 11.731 10.864 11.4711L8.00195 8.60965L5.13988 11.4711C4.87927 11.731 4.45802 11.731 4.19741 11.4711C3.9368 11.2104 3.9368 10.7885 4.19741 10.5279L7.53072 7.19595C7.66069 7.06597 7.83132 7.00065 8.00195 7.00065Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00195 2.33562C8.17258 2.33562 8.34321 2.40094 8.47319 2.53091L11.8065 5.86288C12.0671 6.12349 12.0671 6.54541 11.8065 6.80602C11.5459 7.06596 11.1246 7.06596 10.864 6.80602L8.00195 3.94461L5.13988 6.80602C4.87927 7.06596 4.45802 7.06596 4.19741 6.80602C3.9368 6.5454 3.9368 6.12349 4.19741 5.86288L7.53072 2.53091C7.66069 2.40094 7.83132 2.33562 8.00195 2.33562Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTop);
export default __webpack_public_path__ + "static/media/double_top.85f234fda783127b966e4568009d4b10.svg";
export { ForwardRef as ReactComponent };